/* global axios */
import ApiClient from './ApiClient';

class CurrenciesAPI extends ApiClient {
  constructor() {
    super('currencies', {});
  }

  list() {
    return axios.get(this.url);
  }
}

export default new CurrenciesAPI();
